import { render } from "./elem-map.vue?vue&type=template&id=2f02be7f&ts=true"
import script from "./elem-map.vue?vue&type=script&lang=ts"
export * from "./elem-map.vue?vue&type=script&lang=ts"

import "./elem-map.vue?vue&type=style&index=0&id=2f02be7f&lang=css"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__